// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"HomeBaffle_mainHeading__1kSI3"};